import RuleOAProviderRequiredToMoveFromFinalSignature from "./Rule/RuleOAProviderRequiredToMoveFromFinalSignature.jsx";
import RuleOAPrimaryDXRequiredToMoveFromFinalSignature from "./Rule/RuleOAPrimaryDXRequiredToMoveFromFinalSignature.jsx";
import RuleGroup3DxRequiredForBillableHcpcsToEnableDSWOButton from "./Rule/RuleGroup3DxRequiredForBillableHcpcsToEnableDSWOButton.jsx";
import RuleApprovedInsuranceRequiredToEnableDSWOButton from "./Rule/RuleApprovedInsuranceRequiredToEnableDSWOButton.jsx";
import RuleE1028HcpcsRequiredToEnableDSWOButton from "./Rule/RuleE1028HcpcsRequiredToEnableDSWOButton.jsx";
import RuleE1028NotAllowedToEnableDSWOButton from "./Rule/RuleE1028NotAllowedToEnableDSWOButton.jsx";
import RuleOAApprovalRequiredBeforeMovingToReadyToDeliver from "./Rule/RuleOAApprovalRequiredBeforeMovingToReadyToDeliver.jsx";
import RuleOASetupDateRequiredBeforeMovingToSetup from "./Rule/RuleOASetupDateRequiredBeforeMovingToSetup.jsx";
import RuleOAEvaluationTypeRequiredWhenLeavingPASubmission from "./Rule/RuleOAEvaluationTypeRequiredWhenLeavingPASubmission.jsx";
import RuleOAEvaluationTypeRequiredWhenLeavingApproval from "./Rule/RuleOAEvaluationTypeRequiredWhenLeavingApproval.jsx";
import RuleOAEvaluationTypeRequiredBeforeMovingFromPaperworkToFinalSignature from "./Rule/RuleOAEvaluationTypeRequiredBeforeMovingFromPaperworkToFinalSignature.jsx";
import RulePatientAgeCannotExceed150Years from "./Rule/RulePatientAgeCannotExceed150Years.jsx";

export default class RuleEngine {
  static context;

  /**
   * Sets the context for the RuleEngine.
   * @param {any} context - The context object to be used by rules.
   */
  static setContext(context) {
    RuleEngine.context = context;
  }

  // Define the rule strings here as an enum for code completion.
  static rules = {
    OA_PROVIDER_REQUIRED_TO_MOVE_FROM_FINAL_SIGNATURE:
      "OA_PROVIDER_REQUIRED_TO_MOVE_FROM_FINAL_SIGNATURE",
    OA_PRIMARY_DX_REQUIRED_TO_MOVE_FROM_FINAL_SIGNATURE:
      "OA_PRIMARY_DX_REQUIRED_TO_MOVE_FROM_FINAL_SIGNATURE",
    OA_APPROVAL_REQUIRED_BEFORE_MOVING_TO_READY_TO_DELIVER:
      "OA_APPROVAL_REQUIRED_BEFORE_MOVING_TO_READY_TO_DELIVER",
    GROUP_3_DX_REQUIRED_FOR_BILLABLE_HCPCS_TO_ENABLE_DSWO_BUTTON:
      "GROUP_3_DX_REQUIRED_FOR_BILLABLE_HCPCS_TO_ENABLE_DSWO_BUTTON",
    APPROVED_INSURANCE_REQUIRED_TO_ENABLE_DSWO_BUTTON:
      "APPROVED_INSURANCE_REQUIRED_TO_ENABLE_DSWO_BUTTON",
    E1028_HCPCS_REQUIRED_TO_ENABLE_DSWO_BUTTON:
      "E1028_HCPCS_REQUIRED_TO_ENABLE_DSWO_BUTTON",
    E1028_NOT_ALLOWED_TO_ENABLE_DSWO_BUTTON:
      "E1028_NOT_ALLOWED_TO_ENABLE_DSWO_BUTTON",
    OA_SETUP_DATE_REQUIRED_BEFORE_MOVING_TO_SETUP:
      "OA_SETUP_DATE_REQUIRED_BEFORE_MOVING_TO_SETUP",
    OA_EVALUATION_TYPE_REQUIRED_WHEN_LEAVING_PA_SUBMISSION:
      "OA_EVALUATION_TYPE_REQUIRED_WHEN_LEAVING_PA_SUBMISSION",
    OA_EVALUATION_TYPE_REQUIRED_WHEN_LEAVING_APPROVAL:
      "OA_EVALUATION_TYPE_REQUIRED_WHEN_LEAVING_APPROVAL",
    OA_EVALUATION_TYPE_REQUIRED_BEFORE_MOVING_FROM_PAPERWORK_TO_FINAL_SIGNATURE:
      "OA_EVALUATION_TYPE_REQUIRED_BEFORE_MOVING_FROM_PAPERWORK_TO_FINAL_SIGNATURE",
    PATIENT_AGE_CANNOT_EXCEED_150_YEARS: "PATIENT_AGE_CANNOT_EXCEED_150_YEARS",
  };

  static ruleClasses = {
    // Business rules that auto-execute on the order
    order_activity: Object.fromEntries([
      [
        this.rules.OA_PROVIDER_REQUIRED_TO_MOVE_FROM_FINAL_SIGNATURE,
        RuleOAProviderRequiredToMoveFromFinalSignature,
      ],
      [
        this.rules.OA_PRIMARY_DX_REQUIRED_TO_MOVE_FROM_FINAL_SIGNATURE,
        RuleOAPrimaryDXRequiredToMoveFromFinalSignature,
      ],
      [
        this.rules.OA_APPROVAL_REQUIRED_BEFORE_MOVING_TO_READY_TO_DELIVER,
        RuleOAApprovalRequiredBeforeMovingToReadyToDeliver,
      ],
      [
        this.rules.OA_SETUP_DATE_REQUIRED_BEFORE_MOVING_TO_SETUP,
        RuleOASetupDateRequiredBeforeMovingToSetup,
      ],
      [
        this.rules.OA_EVALUATION_TYPE_REQUIRED_WHEN_LEAVING_PA_SUBMISSION,
        RuleOAEvaluationTypeRequiredWhenLeavingPASubmission,
      ],
      [
        this.rules.OA_EVALUATION_TYPE_REQUIRED_WHEN_LEAVING_APPROVAL,
        RuleOAEvaluationTypeRequiredWhenLeavingApproval,
      ],
      [
        this.rules
          .OA_EVALUATION_TYPE_REQUIRED_BEFORE_MOVING_FROM_PAPERWORK_TO_FINAL_SIGNATURE,
        RuleOAEvaluationTypeRequiredBeforeMovingFromPaperworkToFinalSignature,
      ],
    ]),
    // Business rules that auto-execute on the patient
    patient: Object.fromEntries([
      [
        this.rules.PATIENT_AGE_CANNOT_EXCEED_150_YEARS,
        RulePatientAgeCannotExceed150Years,
      ],
    ]),
    // Business rules that do not auto-execute as part of the patient or order
    component: Object.fromEntries([
      [
        this.rules.GROUP_3_DX_REQUIRED_FOR_BILLABLE_HCPCS_TO_ENABLE_DSWO_BUTTON,
        RuleGroup3DxRequiredForBillableHcpcsToEnableDSWOButton,
      ],
      [
        this.rules.APPROVED_INSURANCE_REQUIRED_TO_ENABLE_DSWO_BUTTON,
        RuleApprovedInsuranceRequiredToEnableDSWOButton,
      ],
      [
        this.rules.E1028_HCPCS_REQUIRED_TO_ENABLE_DSWO_BUTTON,
        RuleE1028HcpcsRequiredToEnableDSWOButton,
      ],
      [
        this.rules.E1028_NOT_ALLOWED_TO_ENABLE_DSWO_BUTTON,
        RuleE1028NotAllowedToEnableDSWOButton,
      ],
    ]),
  };

  /**
   * Evaluates a single rule by key.
   * @param {string} ruleKey - The key of the rule to evaluate.
   * @param {object|null} currentData - Optional precomputed chart data or
   * orderFlat data.
   * @param {object|null} futureData - Optional future chart data or orderFlat
   * data.
   * @param {string|null} orderActivityId - Optional order activity ID.
   * @param {string} typeKey - The type of rule (e.g., "order_activity").
   * @returns {{message: string, passed: boolean, detail: any}} The result of
   * the rule evaluation.
   */
  static evaluate(ruleKey, currentData, futureData, orderActivityId, typeKey) {
    const RuleClass = this.ruleClasses[typeKey][ruleKey];
    const currentChartData = this.convertOrderFlatToChartData(currentData);
    const futureChartData = this.convertOrderFlatToChartData(futureData);
    const instance = new RuleClass(
      currentChartData,
      futureChartData,
      orderActivityId,
    );
    const result = instance.run();

    return {
      message: result.message,
      passed: result.passed,
      detail: result.detail || null,
    };
  }

  /**
   * Evaluates all rules of a given type against the provided order data.
   * @param {object|null} currentData - Current chart data or orderFlat data.
   * @param {object|null} futureData - Future chart data or orderFlat data.
   * @param {string|null} orderActivityId - Optional order activity ID.
   * @param {string} typeKey - The type of rules to evaluate (e.g.,
   * "order_activity").
   * @returns {Object} An object mapping rule keys to their evaluation
   * results.
   */
  static evaluateAll(currentData, futureData, orderActivityId, typeKey) {
    return Object.keys(this.ruleClasses[typeKey]).reduce(
      (accumulator, ruleKey) => {
        accumulator[ruleKey] = this.evaluate(
          ruleKey,
          currentData,
          futureData,
          orderActivityId,
          typeKey,
        );
        return accumulator;
      },
      {},
    );
  }

  /**
   * Converts a flat order object to the expected chart data structure.
   * @param {object} orderFlat - The flat order object.
   * @returns {object|null} The chart data object or null if input is not a
   * flat order.
   */
  static convertOrderFlatToChartData(orderFlat) {
    const isOrderFlat = orderFlat.id;

    if (!isOrderFlat) {
      return orderFlat;
    }
    const orderId = orderFlat.id;
    const patientId = orderFlat.patient?.id || orderFlat.patientId;
    const accountId =
      orderFlat.activity?.account?.id ||
      orderFlat.patient?.account?.id ||
      orderFlat.accountId;

    const chartData = {
      serviceOrderReason: {},
      patientIssueNote: {},
      patientIssue: {},
      apiResult: {},
      brightreeInvoice: {},
      serviceQuote: {},
      note: {
        [orderId]: [],
      },
      account: accountId
        ? {
            [accountId]:
              orderFlat.activity?.account || orderFlat.patient?.account || {},
          }
        : {},
      patient: patientId
        ? {
            [patientId]: orderFlat.patient || {},
          }
        : {},
      orderActivity: {
        [orderId]: orderFlat,
      },
      orderActivityProducts: {
        [orderId]: orderFlat.orderActivityProducts || [],
      },
      product: (orderFlat.orderActivityProducts || []).reduce(
        (productMap, orderActivityProduct) => {
          const productId = orderActivityProduct.productsId;
          if (productId && orderActivityProduct.products) {
            productMap[productId] = orderActivityProduct.products;
          }
          return productMap;
        },
        {},
      ),
      activity: orderFlat.activity?.id
        ? {
            [orderFlat.activity.id]: orderFlat.activity,
          }
        : {},
      orderActivityApprovals: {
        [orderId]: orderFlat.orderActivityApprovals || [],
      },
      approval: (orderFlat.orderActivityApprovals || []).reduce(
        (approvalMap, orderActivityApproval) => {
          const approvalId = orderActivityApproval.approvalsId;
          if (approvalId && orderActivityApproval.approvals) {
            approvalMap[approvalId] = orderActivityApproval.approvals;
          }
          return approvalMap;
        },
        {},
      ),
      provider: orderFlat.orderingProvider?.id
        ? {
            [orderFlat.orderingProvider.id]: orderFlat.orderingProvider,
          }
        : {},
      diagnosisCode: [
        orderFlat.firstDiagnosisCode,
        orderFlat.secondDiagnosisCode,
        orderFlat.thirdDiagnosisCode,
        orderFlat.fourthDiagnosisCode,
      ]
        .filter(Boolean)
        .reduce((diagnosisCodeMap, diagnosisCode) => {
          if (diagnosisCode?.id)
            diagnosisCodeMap[diagnosisCode.id] = diagnosisCode;
          return diagnosisCodeMap;
        }, {}),
    };

    return chartData;
  }
}
